/* eslint-disable no-await-in-loop */
import * as R from 'ramda';
import config from 'config';

export const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
export const rewriteAppUrl = R.replace(/app/, 'connect');
export const rewriteConnectUrl = R.replace(/connect/, 'app');
export const normalizeTemplateFileUrl = (url) =>
  config.IN_DEV ? `http://localhost:4004${url}` : `${config.CORE_URL}${url}`;

export const API_V12_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  // Still needed by some endpoints that use cookies auth instead of token
  'X-Api-Version': 12,
};

export const API_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export const setCustomHeaders = (token, apiVersion = 12) => ({
  ...API_V12_HEADERS,
  Authorization: `Token ${token}`,
  'X-Api-Version': String(apiVersion),
});

export const getSortParam = ({ order, columnKey }) => {
  if (!columnKey) {
    return 'name';
  }

  const param = [order === 'descend' ? '-' : '', columnKey].join('');
  return param;
};

export const mapCustomFilterToQuery = (field, filterObj) => {
  const queryItems = R.compose(
    R.mergeAll,
    R.map((v) =>
      filterObj.options?.useOnlyName
        ? {
            [field]: v[1],
          }
        : { [`${field}__${v[0].toLowerCase()}`]: v[1] }
    ),
    R.filter((v) => v[1]),
    R.toPairs
  )(R.omit(['options'], filterObj));
  return queryItems;
};

export const hasCustomFilterActive = R.compose(
  R.any((v) => v),
  R.flatten,
  R.map((v) => R.values(R.omit(['options'], v))),
  R.values
);

export const getCustomFiltersParams = (filters) => {
  if (hasCustomFilterActive(filters)) {
    return R.compose(
      R.mergeAll,
      R.values,
      R.mapObjIndexed((value, key) => mapCustomFilterToQuery(key, value))
    )(filters);
  }
  return {};
};

export async function loadAllPages(apiFn, userToken, params = {}) {
  const limit = params.limit ?? 40;
  const { count, results, next } = await apiFn(
    { page: 1, ...params },
    userToken
  );

  if (!next) {
    return { count, results };
  }

  const numOfPages = count / limit;
  const extraPages = R.range(2, numOfPages + 1);
  const extraData = await Promise.all(
    extraPages.map((page) => apiFn({ limit, page, ...params }, userToken))
  );
  const extraItems = R.flatten(R.pluck('results', extraData));
  const completeList = R.concat(results, extraItems);
  return { count, results: completeList };
}

export async function requestUpload({
  url,
  apiVersion = 8,
  method = 'POST',
  userToken,
  requestData,
}) {
  const form = new FormData();

  Object.keys(requestData).forEach((k) => {
    form.append(k, requestData[k]);
  });

  const response = await fetch(url, {
    body: form,
    headers: {
      'x-api-Version': apiVersion,
      Authorization: `Token ${userToken}`,
    },
    method,
  });

  const data = response.json();

  if (response.status !== 200 && response.status !== 202) {
    const error = new Error('Upload request error');
    error.statusCode = response.status;
    throw error;
  }

  return data;
}

// function download(content: any, fileName: string, contentType: string) {
export function downloadFile(content, fileName, contentType) {
  const a = document.createElement('a');
  const ext = contentType;
  a.href = URL.createObjectURL(content);
  a.download = `${fileName}.${ext}`;
  a.click();
}
